import CleaningIcon from '../Images/cleaning-icon.svg'


const homeKeeper = [


    {
        id: 35, 
        image: CleaningIcon,
        option: 'Studio Flat',
        desc: 'Dusting all surfaces and furniture, Vacuuming carpets and floors, Mopping hard floors, Cleaning the bathroom, Wiping down kitchen surfaces, Emptying trash bins, Changing bed linens'  
    },
    {
        id: 36, 
        image: CleaningIcon,
        option: '1 Bedroom Flat',
        desc: 'Dusting all surfaces and furniture, Vacuuming carpets and floors, Mopping hard floors, Cleaning the bathroom, Wiping down kitchen surfaces, Emptying trash bins, Changing bed linens'  
    },{
        id: 37, 
        image: CleaningIcon,
        option: '2 Bedroom Flat',
        desc: 'Dusting all surfaces and furniture, Vacuuming carpets and floors, Mopping hard floors, Cleaning the bathroom, Wiping down kitchen surfaces, Emptying trash bins, Changing bed linens'  
    },

]

export default homeKeeper;